// =====================================================================
//  Compte de service d'un client — routes proxy :
//    GET  /client/{id}/serviceaccount              (clé masquée)
//    POST /client/{id}/serviceaccount              (création)
//    POST /client/{id}/serviceaccount/reveal       (clé en clair, tracé)
//    POST /client/{id}/serviceaccount/regenerate   (nouvelle clé, tracé)
// =====================================================================

import {JsonFetchJson} from "../../Helper/FetchHelper.js";
import {ResponseApi} from "../../Model/ResponseApi.js";
import {IClientServiceAccountModel} from "../../Model/Client/ClientServiceAccountModel.js";

export class ClientServiceAccount {
    /** Compte du client, ou null s'il n'en a pas. */
    public static Read = async (clientId: string): Promise<IClientServiceAccountModel | null> => {
        const response = await JsonFetchJson.Get<ResponseApi<IClientServiceAccountModel | null>>(`/client/${clientId}/serviceaccount`);
        return response?.Data ?? null;
    };

    public static Create = (clientId: string) => ClientServiceAccount.#post(clientId, "");
    public static Reveal = (clientId: string) => ClientServiceAccount.#post(clientId, "/reveal");
    public static Regenerate = (clientId: string) => ClientServiceAccount.#post(clientId, "/regenerate");

    /** Erreurs métier déjà notifiées par FetchAbstract.checkResponseApi : renvoie null. */
    static #post = async (clientId: string, action: string): Promise<IClientServiceAccountModel | null> => {
        const response = await JsonFetchJson.Post<ResponseApi<IClientServiceAccountModel>>(`/client/${clientId}/serviceaccount${action}`);
        return response?.Data ?? null;
    };
}
